<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Messages</li>
      </ol>
    </div>
    <div class="inbox-wrap-holder">
      <div class="inbox-wrap" v-if="messagesAll.latestDate != null">
        <div class="inbox-sidebar">
          <ul class="inbox-list-messages">
            <li class="" v-for="(message,key) in messagesAll" v-if="messagesAll[key][0]"
                :class="{'unread':messagesAll[key][0].is_read===0,'active':messagesAll[key][0].date===dateParam}">
              <a href="javascript:void(0);" v-if="messagesAll[key][0]"
                 v-on:click="getMessagesByDate(messagesAll[key][0].date,messagesAll[key][0].roster_schedule_id)">
                <!--<pre ><code>{{ messagesAll[key][0].date  }}</code></pre>-->
                <div class="inbox-list-unread">
                  <i class="ico-fill-circle"></i>
                </div>
                <div class="inbox-list-message-con">
                  <div class="inbox-list-message-title">
                    <strong class="title-mes">{{ messagesAll[key][0].company.name }}:
                      {{ messagesAll[key][0].date | moment("dddd, MMMM DD, Y") }}</strong>
                    <span class="sub-title-mes">{{ messagesAll[key][0].created_at | moment("MM.DD.Y HH:mm a") }}</span>
                  </div>
                  <div class="inbox-list-message-resume">{{ messagesAll[key][0].message }}</div>
                  <div class="inbox-list-message-daylink">Message on day</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="inbox-viewer-wrap">
          <message-section :messagesAllByDate="messagesAllByDate" :selectDate="selectDate"
                           :roster_schedule_id="roster_schedule_id"
                           v-on:send-result-values="showResultData"></message-section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../router/router'
import messageSection from '../Settings/Partials/message_section'


export default {
  components: {
    'messageSection': messageSection,
  },
  data() {
    return {
      company_id: this.$store.getters.getSelectedCompany.id,
      dateParam: this.$route.query.date,
      messagesAll: [],
      messagesAllByDate: [],
      selectDate: '',
      roster_schedule_id: '',
      // latestDate: '',
      date:null
    }
  },
  serverPrefetch() {
  },
  created() {
    this.messages();
    // console.log(this.$route.query.date,'dateedf');
  },
  mounted() {
   
  },
  methods: {
    showResultData: function (date, id) {
      this.getMessagesByDate(date);
    },
    getMessagesByDate(date, roster_schedule_id) {
      this.dateParam = date;
      this.$router.push('/messages/inbox/?date=' + date);
      this.selectDate = date;
      this.roster_schedule_id = roster_schedule_id;
      this.$axios.get(this.$messagesByDate, {
        params: {
          company_id: this.company_id,
          // roster_schedule_id: roster_schedule_id,
          date: date,
        },
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.status == 200) {
          this.messagesAll = res.data.result.messageAll;
          this.messagesAllByDate = res.data.result.messageAllByDate;
        }
      });
    },
    messages() {
  let params = {
    company_id: this.company_id,
  };
  this.$axios.get(this.$messages, {
    params: params,
    headers: this.getAuthHeader(),
  }).then(res => {
    // if (res.status === 200) {
    //   console.log('Response data:', res.data.result.schedules);
    //   this.messagesAll = res.data.result.schedules;
    //   if (this.messagesAll.length > 0 && this.messagesAll[0] && this.messagesAll[0].latestDate != null) {
    //     this.getMessagesByDate(this.messagesAll[0].latestDate.date, this.messagesAll[0].latestDate.roster_schedule_id);
    //   }
    // }
  }).catch(error => {
    console.error("Error fetching messages:", error);
  });
},

  }
}
</script>
